module.exports = __webpack_public_path__ + "static/red-dragon-very-old-e7eea8e72b62592b0875a4053d60e261.jpg";